


const cameras = [
	[ 'Tramway' , 'https://servicev5.nmroads.com/RealMapWAR/GetCameraImage?ts=0&cameraName=I-25NBTramway' ] ,
	[ 'Bernalillo' , 'https://servicev5.nmroads.com/RealMapWAR/GetCameraImage?ts=0&cameraName=I-25NB@US-550' ] ,
	[ 'Rosario' , 'https://servicev5.nmroads.com/RealMapWAR/GetCameraImage?ts=0&cameraName=I-25@La_Bajada_Lower' ] ,
	[ 'La Cienega' , 'https://servicev5.nmroads.com/RealMapWAR/GetCameraImage?ts=0&cameraName=I-25NB@LaCienega' ] ,
	[ 'Santa Fe, Carillos Rd' , 'https://servicev5.nmroads.com/RealMapWAR/GetCameraImage?ts=0&cameraName=I-25NB@Cerrillos_Road' ] ,
	[ 'Santa Fe, Old Pecos' , 'https://servicev5.nmroads.com/RealMapWAR/GetCameraImage?ts=0&cameraName=i-25sb@oldpecostrail' ] ,
	[ 'Glorietta/Valencia' , 'https://servicev5.nmroads.com/RealMapWAR/GetCameraImage?ts=0&cameraName=Glorietta' ] ,
	[ 'Rowe' , 'https://servicev5.nmroads.com/RealMapWAR/GetCameraImage?ts=0&cameraName=I-25@RoweNB' ] ,
	[ 'Las Vegas' , 'https://servicev5.nmroads.com/RealMapWAR/GetCameraImage?ts=0&cameraName=I-25@LasVegas' ] ,
	[ 'Springer' , 'https://servicev5.nmroads.com/RealMapWAR/GetCameraImage?ts=0&cameraName=I-25@Springer' ] ,
	[ 'Raton' , 'https://servicev5.nmroads.com/RealMapWAR/GetCameraImage?ts=0&cameraName=I-25@Raton' ] ,
	[ 'Raton Pass' , 'https://servicev5.nmroads.com/RealMapWAR/GetCameraImage?ts=0&cameraName=RatonPass' ] ,
]


export default function RoadPictures () {
	return ( <div>
		{
			cameras.map ( (info) => (
				<Camera info={info} key={info[0]}/>
			))
		}
	</div>)
}


function Camera ({ info }) {
	const titleStyle = {
		fontSize:		'120%' ,
		marginBottom:	'8px' ,
		fontWeight:		'bold' ,
	}
	const imgStyle = {
		marginTop:		'8px' ,
	}
	
	return (
		<div>
			<p style={titleStyle}>{info[0]}</p>
			<p style={imgStyle}>
				<img src={info[1]}/>
			</p>
		</div>
	)
}
